import gql from 'graphql-tag';

export const tagFieldsFragment = gql`
    fragment tagFields on Tag {
        uuid
        name
    }
`;

export const tagsPaginationFragment = gql`
    fragment tagsPagination on TagList {
        page
        limit
        total
        count
    }
`;
